import React, { ReactNode, useState, useEffect } from "react";
import SideBar from "../SideBar";

import Topbar from "../Topbar";

import { PageContainer, PageHeaderContainer, PageTitle } from "./styles";
import { useAuth } from "../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

const LayoutIframe: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { navigationAction } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDesktopExpanded, setIsDesktopExpanded] = useState(() => {
    const savedState = localStorage.getItem("@FixitApp:SidebarExpanded");
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  useEffect(() => {
    localStorage.setItem("@FixitApp:SidebarExpanded", JSON.stringify(isDesktopExpanded));
  }, [isDesktopExpanded]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <SideBar 
        extendedMode={isDesktopExpanded} 
        setExtendedMode={setIsDesktopExpanded}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
      />
      <PageContainer
        noPadding={false}
        isMenuOpen={isMenuOpen}
        isIframe={true}
        isDesktopExpanded={isDesktopExpanded}
      >
        <Topbar 
          isMenuOpen={isMenuOpen} 
          toggleMenu={toggleMenu} 
          extendedMode={isDesktopExpanded} 
          setExtendedMode={setIsDesktopExpanded} 
        />
        <div className="content-area">
          {!!navigationAction && (
            <PageHeaderContainer>
              {!!navigationAction.hasButton && (
                <>
                  {navigationAction.action === "back" && (
                    <RiArrowLeftLine onClick={() => navigate(-1)} />
                  )}
                  {navigationAction.action === "function" && (
                    <RiArrowLeftLine onClick={navigationAction.functionToBeExecuted} />
                  )}
                </>
              )}
              <PageTitle>{navigationAction.description}</PageTitle>
            </PageHeaderContainer>
          )}
          {children}
        </div>
      </PageContainer>
    </>
  );
};

export default LayoutIframe;
